import React from 'react';
import ImageItem from './ImageItem';
import AudioItem from 'shared/components/RefFiles/AudioItem';
import { IMediumAttributes } from 'shared/interfaces/IMedium';
import { DocumentFileIcon } from '@room-match/shared-ui-components';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { FileItem } from './MediaItems.styles';
import { CustomTooltip } from 'pages/Opportunities/components/CustomTooltip/CustomTooltip';

interface Props {
  file: IMediumAttributes;
}

const MediaItem: React.FC<Props> = ({ file }) => {
  const { medium: med, attachment: src } = file;
  const medium = med?.data?.attributes || med;
  console.log('file', file);

  const renderItem = () => {
    switch (medium?.file_type?.toLocaleLowerCase()) {
      case 'image':
        return <ImageItem src={src} />;
      case 'video':
        return <video src={src} controls style={{ width: '100%' }} />;
      case 'audio':
        return <AudioItem aud={file} />;
      case 'document':
        return (
          <CustomTooltip title={medium.file_name}>
            <FileItem onClick={() => window.open(`${src}`, '_blank')}>
              <DocumentFileIcon />
              <CustomTypography fontSize={14}>{medium.file_name}</CustomTypography>
            </FileItem>
          </CustomTooltip>
        );
      default:
        //handle other types
        return null;
    }
  };

  return renderItem();
};

export default MediaItem;
